import React, { Component, useEffect, useRef, useState } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { DataTable} from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Messages } from 'primereact/messages';
import { useNavigate, useParams } from 'react-router-dom';
import CmsService from '../../../service/CmsService';
import { QuePreview } from './QuePreview';
import { Panel } from 'primereact/panel';
import { useTranslation } from 'react-i18next';

export function QueImportList({id})
{
    const {t}=useTranslation();
    var {id} = useParams();
    const navigate = useNavigate();
    const [questions,setQuestions] = useState([]);
    const [selectedQue,setSelectedQue] = useState(null);
    const messages = useRef(null);

    useEffect(()=>{
        CmsService.getImportedQuestions(id).then((ret)=>{
            setQuestions(ret);
            if(ret.length>0)
                setSelectedQue(ret[0]);
        }).catch((err)=>{
            console.log("err:"+err);
            showError(err);
        });
    },[id]);

    const showError=(err) => {
		messages.current.show({ severity: 'error', summary: 'error', detail: err.message });
	}	
    const onEdit=(e)=>{
        if(selectedQue!=undefined)
            navigate('/question/'+selectedQue.id);
    }
    const previewPanelHeader=()=>{
        return(
            <div className="flex justify-content-between flex-wrap p-toolbar">
                <label>{t('Preview')}</label>
                <div className="flex gap-1"><Button label={t('Edit')} onClick={onEdit}/><Button label={t('Delete')}/></div>
            </div>
        );
    }
    const onSelectQue=(e)=>{
        setSelectedQue(e.value);
    }
    return(
    <Card>
    <h4>{t('Imported_Questions')}</h4>
    <Messages ref={messages}></Messages>
        <div className='grid'>
        <div className='col'>
            <DataTable value={questions} selectionMode="single" selection={selectedQue} dataKey="id" onSelectionChange={onSelectQue}>
                <Column header={t('Id')} field='id'/>
                <Column header={t('Answer')} field='answer'/>
                <Column header={t('Difficulty')} field='difficulty'/>
                <Column header={t('Course')} field='courseName'/>
                <Column header={t('Topic')} field='topicName'/>
            </DataTable>
        </div>
        <Panel className="col" header={t('Preview')} headerTemplate={previewPanelHeader}>
            {selectedQue!=undefined?<QuePreview id={selectedQue.id}/>:<></>}
        </Panel>
        </div>
    </Card>
    );
}
export default QueImportList;